/* global $ */
import './plugins/lazyload'
import './main/cegep.anchors'
import './international/main/spk.slider'
import './international/main/cegep.cookieconsent'
import './main/spk.expandable'
import './main/cegep.trainings'
import './main/cegep.responsive-tables'
import './plugins/share'
import './plugins/jquery-ui-1.10.3.custom.min'
import './international/main/cegep.menu'
import './international/main/cegep.resize'
import './main/cegep.forms'

// Adds a class to html for mobile and non-mobile
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
  $('html').addClass('mobile')
} else {
  $('html').addClass('non-mobile')
}
